export enum FunnelActionsCookies {
  FMP_POST_ZIP_MODAL = 'fmp-post-zip-modal',
  FMP_POST_ZIP_MODAL_QUIZ = 'fmp-post-zip-modal-quiz',
  FMP_POST_ZIP_MODAL_GRID = 'fmp-post-zip-modal-grid',
  FMP_QUIZ_SHORT = 'fmp-quiz-short',
  FMP_QUIZ_LONG = 'fmp-quiz-long',
  FMP_TPGRID = 'fmp-tpgrid',
  FMP_CGRID = 'fmp-cgrid',
  FMP_GUIDED_PATH_TPGRID = 'fmp-guided-path-tpgrid',
  FMP_GUIDED_PATH_HOMEINFO = 'fmp-guided-path-homeinfo',
}
